import React from 'react'
import './Player.css';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'

export default function Player(props) {
    const {name, salary, src} = props.player; 
    const handleAddPlayer = props.handleAddPlayer; 
    return (
        <div className="player">
            <div className='img-box '>
                <img className="img-fluid" src={src} alt=""/>
            </div>
            <div className='content-box'>
                <h3>Name: {name}</h3>
                <h4>Salary: {salary}</h4>
                <button className='btn btn-primary' onClick={() => handleAddPlayer(props.player)}>Add Player</button>
                
            </div>
        </div>
    )
}
